import { firebaseSafeKey } from '../lib/firebaseKey';

export const CATEGORY_META = {
  Groceries: { icon: 'cart', tint: '#1F9D5A' },
  'Eating Out': { icon: 'food', tint: '#D98A1F' },
  Housing: { icon: 'home', tint: '#2C6FB5' },
  Utilities: { icon: 'bolt', tint: '#7A5AE0' },
  Cars: { icon: 'car', tint: '#3A9BB5' },
  Transport: { icon: 'car', tint: '#3A9BB5' },
  'Health & Wellness': { icon: 'heart', tint: '#E0533C' },
  Health: { icon: 'heart', tint: '#E0533C' },
  Subscriptions: { icon: 'repeat', tint: '#C8527E' },
  Entertainment: { icon: 'play', tint: '#D04545' },
  Personal: { icon: 'user', tint: '#7A5AE0' },
  Income: { icon: 'income', tint: '#1F9D5A' },
  'Accounts & Transfers': { icon: 'bank', tint: '#3A9BB5' },
  'Credit Cards': { icon: 'wallet', tint: '#C8527E' },
  Other: { icon: 'dots', tint: '#79808B' },
};

export const DEFAULT_META = { icon: 'dots', tint: '#79808B' };

// Curated set of icons users can assign to a category. Names map to
// ICON_PATHS in icons.jsx.
export const CATEGORY_ICON_LIBRARY = [
  'cart', 'bag', 'food', 'coffee', 'home', 'bolt', 'droplet', 'wifi',
  'car', 'fuel', 'plane', 'heart', 'dumbbell', 'repeat', 'play', 'music',
  'gamepad', 'gift', 'shirt', 'book', 'graduation', 'phone', 'paw', 'user',
  'briefcase', 'income', 'bank', 'wallet', 'card', 'coins', 'target',
  'sparkle', 'tag', 'dots',
];

// Palette offered in the color picker.
export const CATEGORY_TINTS = [
  '#1F9D5A', '#3A9BB5', '#2C6FB5', '#7A5AE0', '#C8527E', '#D04545',
  '#E0533C', '#D98A1F', '#C9A227', '#5B8C3E', '#0E9488', '#566BC4',
  '#9B59B6', '#E0567D', '#E07A3C', '#79808B',
];

// User-supplied per-category overrides ({ [name]: { icon, tint } }).
// Updated from App.jsx when the Firebase `categoryMeta` value loads so that
// the synchronous getCategoryMeta() call sites pick up customizations.
let userOverrides = {};

export const setCategoryMetaOverrides = (overrides) => {
  userOverrides = overrides && typeof overrides === 'object' ? overrides : {};
};

export const getCategoryMeta = (name) => {
  const base = CATEGORY_META[name] || DEFAULT_META;
  // userOverrides mirrors Firebase's categoryMeta keys, which are sanitized
  // (Firebase path segments can't contain . # $ [ ] /) — look up the same way.
  const override = userOverrides[firebaseSafeKey(name)];
  if (override && (override.icon || override.tint)) {
    return {
      icon: override.icon || base.icon,
      tint: override.tint || base.tint,
    };
  }
  return base;
};

export const buildCategoryList = (names) =>
  names.map((name) => ({ name, ...getCategoryMeta(name) }));
